import styled from "@emotion/styled";

export const CitationWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "4/14",
  marginBlock: theme?.breakpoints?.isMobile ? 20 : 30,
}));
